import { useSelector } from 'react-redux'

import { faSearch } from '@fortawesome/pro-solid-svg-icons'

import StudentsSelector from './StudentsSelector'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../../antd/Buttons/IconButton'
import { Student } from '../../../../utils/entities/student'
import SearchStudentFormModalProvider from '../../../../Providers/Forms/StudentForm/SearchStudentModalProvider'

const ExtendedStudentsSelector = ({ disabled, loading, notFoundContent, school, students, style, values, showSearch, onChange, onStudentSubmit }) => {
  const t = useSelector(selectTranslate)

  const renderDropdown = onClick => menu => (
    <div>
      {menu}
      <div className='flex-col m-4' onMouseDown={e => e.preventDefault()}>
        <IconButton
          text={t('extended_student_selector.dropdown_button.label')}
          icon={faSearch}
          onClick={() => onClick(handler => ({ ...handler, data: new Student(), callback: onStudentSubmit }))}
        />
      </div>
    </div>
  )

  return (
    <SearchStudentFormModalProvider school={school}>
      <StudentsSelector
        disabled={disabled}
        loading={loading}
        notFoundContent={notFoundContent}
        students={students}
        style={style}
        values={values}
        showSearch={showSearch}
        dropdownRender={renderDropdown}
        onChange={onChange}
      />
    </SearchStudentFormModalProvider>
  )
}

export default ExtendedStudentsSelector
